// extracted by mini-css-extract-plugin
module.exports = {"search-icon":"e2ff468f85--search-icon--vQlL6"};